var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: _vm.classes }, [
    _c(
      "fieldset",
      { class: _vm.mdsNS("form__checkbox-group"), attrs: { role: "group" } },
      [
        !_vm.showCheckAll && !!_vm.title
          ? _c("legend", { class: _vm.mdsNS("form__checkbox-group-label") }, [
              _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showCheckAll
          ? _c("markets-ui-checkbox", {
              attrs: {
                namespaced: _vm.namespaced,
                size: _vm.size,
                label: _vm.title,
                value: _vm.title,
                checked: _vm.selectedAllState === "all"
              },
              on: { change: _vm.handleClickAll }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.visibleDataModel, function(item) {
          return _c("markets-ui-checkbox", {
            key: item.id,
            attrs: {
              namespaced: _vm.namespaced,
              label: item.name,
              checked: item.selected,
              value: item.id,
              disabled: item.disabled,
              size: _vm.size
            },
            on: { change: _vm.handleClickItem }
          })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }